export const DocumentValidFileTypes = [
    'application/pdf' 
];
